module.exports = __webpack_public_path__ + "static/media/Wide Joint Space.fce38c8b.png";